import React from 'react';
import * as styledComponents from './styles';


const ItemElement = ({ item, deleteItem }) => {
  return (
    <styledComponents.Item>
      <styledComponents.Title>{item.name.toUpperCase()}</styledComponents.Title>
      <styledComponents.Price>€ {item.priceEUR}</styledComponents.Price>
      <styledComponents.CloseButtonContainer onClick={()=>deleteItem(item)}>
        <styledComponents.CloseButton />
      </styledComponents.CloseButtonContainer>
    </styledComponents.Item>
  );
}

export default ItemElement;
